module.exports = __webpack_public_path__ + "img/P000010649.804286b6.jpg";